import theme from '@styles/theme';
export default {
  blockContainer: (isFullHeight: boolean, hasImage: boolean) => {
    const gridSchema = isFullHeight && hasImage ? {
      gridAutoFlow: ['row', 'row', 'column'],
      gridTemplateColumns: ['', '', '50% 50%', '50% 50%', '442px auto']
    } : {};
    return {
      position: 'relative',
      height: '100%',
      width: '100%',
      maxWidth: hasImage ? '100%' : ['100%', '100%', '100%', '100%', '442px'],
      mb: ['8px', '8px', '0'],
      border: `solid 1px ${theme.rawColors.lightGreyBg}`,
      padding: isFullHeight && hasImage ? '0' : '40px',
      display: isFullHeight && hasImage ? 'grid' : 'block',
      ...gridSchema
    };
  },
  blockHolder: (isFullHeight: boolean, hasImage: boolean) => ({
    padding: isFullHeight && hasImage ? '40px' : '0',
    flex: isFullHeight && hasImage ? '0 0 40%' : 'auto',
    display: 'flex',
    flexFlow: 'column',
    height: '100%'
  }),
  heading: {
    mb: ['16px', '16px', '16px', '16px', '24px']
  },
  text: (noMargin = false) => ({
    marginBottom: noMargin ? '0' : '24px',
    fontSize: theme.fontSizes.text
  }),
  imageContainer: {
    width: '100%',
    height: ['257px', '300px', '100%'],
    position: 'relative',
    overflow: 'hidden'
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%'
  },
  voxButton: {
    marginTop: ['4px', '4px', 'auto']
  },
  voxButtonContainer: {
    display: 'flex',
    flexGrow: 1
  },
  descriptionList: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column nowrap',
    width: '100%',
    height: '100%',
    m: ['24px 0 4px 0', '24px 0 4px 0', '24px 0 4px 0', '24px 0 24px 0']
  },
  descriptionSingleItem: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'flex-start',
    marginBottom: '20px'
  },
  descriptionSingleItemText: {
    ml: '8px',
    lineHeight: '24px',
    fontSize: theme.fontSizes.smallText
  }
};